import { Card, CardContent, Grid } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { DataGrid } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { GET_ANNUAL_MBR, SAVE_MBR_WORKFLOW } from '../../common/URLs';
import { FinancialYearDropdown } from './FinancialYearDropdown';
import { toast } from 'react-toastify';
import { loaderService } from '../../common/custom-loader/loader-service';

import { getLocalStorageItem } from '../../common/localStorageUtils';
import { userData, uuid } from '../../common/spinLoader';
import { CustomButton } from '../../common/custom-button/customButton';
import { ConfirmationPopover } from '../../common/commonPopovers/confirmationPopover';
import { ApproveIcon, CloseIcon } from '../../common/icons';
import apiClient from '../../axios';


export const MbrWorkflow = () => {
  const userLoggedIn = userData.user.userRoles?.[0].roleName
  const [annualMbrData, setAnnualMbrData] = useState([]);
  const [pageSize, setPageSize] = React.useState(10);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState();
  const [selectedData, setSelectedData] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const [approveDialog, setApproveDialog] = useState(false);
  const handleApproveDialogOpen = () => setApproveDialog(true);
  const handleApproveDialogClose = () => setApproveDialog(false);
  const [rejectDialog, setRejectDialog] = useState(false);
  const handleRejectDialogOpen = () => setRejectDialog(true);
  const handleRejectDialogClose = () => setRejectDialog(false);
  const [actionType, setActionType] = useState();

  const columns = [
    { field: 'stakeholderUrn', headerName: 'URN', width: 190, editable: false },
    { field: 'stakeholderType', headerName: 'Type', editable: false },
    { field: 'stakeholderMbr', headerName: 'Annual MBR(in MT)', editable: false },
  ];
  const getSelectedValue = (dataToBePassed) => {
    setSelectedFinancialYear(dataToBePassed);
    getAnnualMbrApi(dataToBePassed);

  }
  const onGrowerSelectionCallback = (value) => {
    setSelectedData([]);
    if (value?.length === 0) setIsButtonDisabled(true)
    else setIsButtonDisabled(false);

    let dataModified = value.map((item) => {
      return {
        "financialYear": selectedFinancialYear,
        "stakeholderUrn": item,
        "action": "action"
      }
    })
    setSelectedData(dataModified)
  }

  // -----------------API Calls-------------------

  const getAnnualMbrApi = (year) => {
    loaderService.showLoader();
    apiClient.post(GET_ANNUAL_MBR,
      {
        "financialYear": year,
        "userRole": userLoggedIn
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        let data = response.data.lstAnnualMBRVM ? response.data.lstAnnualMBRVM: []
        setAnnualMbrData(data);
        loaderService.hideLoader();

      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const onConfirmAction = () => {
    handleApproveDialogClose();
    handleRejectDialogClose();
    loaderService.showLoader();
    apiClient.post(SAVE_MBR_WORKFLOW,
      {
        "annualMbrLst": selectedData,
        "action": actionType
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          "Content-Type": "application/json"
        }
      })
      .then((response) => {
        response.data.isSuccess === true ? toast.success(response.data.message) : toast.error(response.data.message)
        getAnnualMbrApi(selectedFinancialYear);
        loaderService.hideLoader();

      }).catch(function (error) {
        toast.error(error.message)
        loaderService.hideLoader();
      });
  }

  const saveMbrWorkflow = (action) => {
    setActionType(action);
    action === "Approved" ? handleApproveDialogOpen() : handleRejectDialogOpen();
  }


  return (
    <Grid container spacing={1}>
      <Grid item xs={12} lg={12}>
        <Card style={{ marginBottom: 10 }}>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={2}>
                <FinancialYearDropdown selectedValue={getSelectedValue} />
              </Grid>
              <Grid item xs={12} lg={10}>
                <Stack direction="row" spacing={1} style={{ float: 'right' }}>
                  <CustomButton startIcon={<ApproveIcon />} title="Approve" onClick={() => saveMbrWorkflow('Approved')} disabled={isButtonDisabled} />
                  <CustomButton startIcon={<CloseIcon />} title="Reject" onClick={() => saveMbrWorkflow('Reject')} disabled={isButtonDisabled} />
                </Stack>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <CardContent>
            <Box sx={{
              height: '300', width: '100%', display: "flex",
              justifyContent: "center",
              alignItems: "center",
              '& .super-app-theme--header': {
                wordWrap: 'break-word',
                wordBreak: 'break-all',
                whiteSpace: 'initial',
              },
              '& .MuiDataGrid-cell--editable': {
                bgcolor: (theme) =>
                  theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
              },
            }}>
              <DataGrid
                autoHeight
                columns={columns}
                rows={annualMbrData}
                getRowId={(row) => row?.stakeholderUrn}
                checkboxSelection
                onSelectionModelChange={(e) => onGrowerSelectionCallback(e)}
                pageSize={pageSize}
                onPageSizeChange={(newPage) => setPageSize(newPage)}
              />
            </Box>
          </CardContent>
        </Card>

      </Grid>
      <ConfirmationPopover onOpen={approveDialog} onConfirm={onConfirmAction} onClose={handleApproveDialogClose} action="Approve" />
      <ConfirmationPopover onOpen={rejectDialog} onConfirm={onConfirmAction} onClose={handleRejectDialogClose} action="Reject" />
    </Grid>


  );
}
